module.exports = __webpack_public_path__ + "img/icon-ticket-refund-color.9038f2e9.svg";